import React from 'react';
import { FOOTER_PROPS, FOOTER_STATE } from './Types';
import PuzzleButton from '../../../UI/button/PuzzleButton';
import { 
  Toolbar, 
  ToolbarItem, 
  ToolbarSpacer
} from '@progress/kendo-react-buttons';
import * as _ from 'lodash';
import { Component } from '../../../../dispatcher/modules';
import dayjs from 'dayjs';
const duration = require('dayjs/plugin/duration');
dayjs.extend(duration);

/**
 * Application/Viewport footer component
 * Contains some application info like current server node, user last login date and application about info.
 */
class Footer extends Component<FOOTER_PROPS, FOOTER_STATE> {
  public state: FOOTER_STATE = {};

  constructor(props) {
    super(props);
    this.state = {
      serverNode: props.serverNode,
      sessionsCount: props.sessionsCount,
      lastLoginDate: props.lastLoginDate
    };
  }

  /**
   * Formats user last login date
   * @param {Date} lastLoginDate
   */
  formatLastDate(lastLoginDate: Date) {
    const today = dayjs();
    const loginDate = dayjs(lastLoginDate);
    // @ts-ignore
    const duration = dayjs.duration(today.diff(loginDate));

    let lastLoginFormat = this.translate('lastLoginTpl', {
      timeStamp: loginDate.format('h:mm a'),
      days: duration.days(),
      hours: duration.hours(),
      minutes: duration.minutes()
    });

    return (
      <>
        <span
          className={'tp-viewport-footer-label tp-viewport-footer-last-login'}
        >
          {this.translate('lastLogin')}
        </span>
        <span>
          {lastLoginFormat}
        </span>
      </>
    );
  }

  /**
   * Updates component state
   * Pass props within object and state will be updated
   * @param {PROPS} props
   */
  updateState = (props: FOOTER_PROPS) => {
    let state = this.state;
    state = _.merge(state, props);
    this.setState(state);
  }

  /**
   * Opens About dialog
   */
  openAbout = () => {
    this.dispatch('openAbout', '', {
      appName: this.props.appName ? this.props.appName : this.translate('appName'),
      appVersion: this.props.appVersion
    });
  };

  /**
   * Opens Active Sessions dialog
   */
  openActiveSessions = (e: any) => {
    e.preventDefault();
    const { sessionsCount } = this.props;

    if (sessionsCount) {
      this.dispatch('openActiveSessions');
    }
  };

  /**
   * @inheritDoc
   */
  renderBody() {
    const { serverNode = null, lastLoginDate, sessionsCount } = this.state;
    return (
      <Toolbar 
        className={'tp-widget tp-viewport-footer tp-viewport-footer-right'}
      >
        <ToolbarItem>
          <span>
            {serverNode ? serverNode : null}
          </span>
        </ToolbarItem>

        <ToolbarSpacer />

        <ToolbarItem>
          <PuzzleButton
            fillMode={'flat'}
            iconClass={'tp-icon tp-info'}
            onClick={this.openAbout}
            size={'small'}
          >
            <span 
              className="tp-text-underline"
            >{this.translate('about')}</span>
          </PuzzleButton>

          {
            sessionsCount ?
              <PuzzleButton
                className={'tp-text-underline'}
                size={'small'}
                fillMode="flat"
                onClick={this.openActiveSessions}
              >
                {this.translate('activeSessions', {
                  sessionsCount
                })}
              </PuzzleButton>
              : null
          }
          <span>
            {lastLoginDate ? this.formatLastDate(lastLoginDate) : null}
          </span>
        </ToolbarItem>
      </Toolbar>
    );
  }
}

export default Footer;
